<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog createfp" width="70%" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">

                            <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
                                <div class="h-rowCon" style="padding-bottom:0">
                                    <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                        <div class="h-pieceTitle2"
                                             style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                            <h1>发票信息</h1>
                                        </div>
                                    </div>
                                    <el-table
                                        ref="multipleTable"
                                        :data="recordList"
                                        stripe
                                        style="width: 100%"
                                        :border="true">
                                        <el-table-column
                                            type="index"
                                            width="40"
                                            label="#">
                                        </el-table-column>
                                        <el-table-column
                                            prop="invoiceNumber"
                                            width="140"
                                            label="发票号码" >

                                            <template slot-scope="scope">
                                                <el-input class="h-tableInput" v-model="scope.row.invoiceNumber" placeholder="发票号码"   ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="invoiceCode"
                                            width="140"
                                            label="发票代码">

                                            <template slot-scope="scope">
                                                <el-input class="h-tableInput" v-model="scope.row.invoiceCode" placeholder="发票代码"   ></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                            prop="invoiceCategory"
                                            width="160"
                                            label="发票类型">
                                            <template slot-scope="scope">
                                                <brselect  category="srm_invoice_type" :v="scope.row.invoiceCategory" v-model="scope.row.invoiceCategory"></brselect>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                            prop="invoiceDate"
                                            width="140"
                                            label="发票日期">
                                            <template slot-scope="scope">
                                                <el-date-picker
                                                    class="h-tableInput"
                                                    v-model="scope.row.invoiceDate"
                                                    style="width: 100%;"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="开始日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                            prop="noTaxAmount"
                                            width="140"
                                            label="未税金额">

                                            <template slot-scope="scope">
                                                <el-input class="h-tableInput" v-model="scope.row.noTaxAmount" placeholder="发票金额"   ></el-input>
                                            </template>
                                        </el-table-column>


                                        <el-table-column
                                            prop="taxRate"
                                            width="90"
                                            label="发票税率">
                                            <template slot-scope="scope">
                                                <brselect  category="cgshuilv" :v="scope.row.taxRate" v-model="scope.row.taxRate" disabled ></brselect>
                                            </template>
                                        </el-table-column>


                                        <el-table-column
                                            prop="includeTaxAmount"
                                            width="140"
                                            label="价税合计">
                                            <template slot-scope="scope">
                                                <el-input class="h-tableInput" v-model="scope.row.includeTaxAmount" placeholder="价税合计"   ></el-input>
                                            </template>
                                        </el-table-column>


                                        <el-table-column
                                            prop="taxAmount"
                                            width="140"
                                            label="发票税额">
                                            <template slot-scope="scope">
                                                <el-input class="h-tableInput" v-model="scope.row.taxAmount" placeholder="发票税额"   ></el-input>
                                            </template>
                                        </el-table-column>


                                        <el-table-column
                                            label="发票附件"
                                            width="160">
                                            <template slot-scope="scope">
                                                <brupload
                                                    :limit="1"
                                                    :refid="scope.row.id"
                                                    reftype="发票-附件"
                                                    @filecallback="fileBack1"
                                                    :uploadflag="true"
                                                    :delflag="true"
                                                    :isTpAndPdfAndXml = 'true'
                                                    :showtime="false">
                                                </brupload>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作"  width="100">
                                            <template slot-scope="scope">
                                                <el-button type="text" size="small" class="h-tableLink h-btn"
                                                           @click="delPlan(scope.$index,scope.row)">删除一行
                                                </el-button>
                                            </template>
                                        </el-table-column>


                                    </el-table>

                                    <div class="h-tableAdd" @click="add">
                                        <a>新增一行</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="h-rowBox ljjtablepaddings12" style="margin-top:60px;padding:0;">

                            <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
                                :border="true"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    prop="orderDate"
                                    label="订单日期"
                                    width="110"
                                    :formatter="formatDate"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="cgCode"
                                    label="订单号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="sapCodeCg"
                                    label="sap订单号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                prop="supplierCode"
                                label="供应商编号"
                                width="110"
                                :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="org"
                                    label="采购公司代码"
                                    width="80"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="proNumber"
                                    label="订单数量"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                prop="amount"
                                label="订单金额"
                                width="110"
                                :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                prop="includeTaxAmount"
                                label="订单含税金额"
                                width="110"
                                :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="taxCode"
                                    label="税率"
                                    width="80">
                                <template slot-scope="scope">
                                    <dictname category="cgshuilv"  :v="scope.row.taxCode"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="80"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                        </el-table>
                        </div>
                        <div class="h-formbLine" style="margin-top: 10px;text-align:right;">
                            <el-button class="h-btn h-formBtn h-bgblue2" @click="submit">提 交</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import big from 'big.js';
    import ss from '../../../api/SystemService';
    export default {
        name: "createApplyToSrmTs",
        data(){
            return {
                form:{
                    invoiceNumber:null,
                    invoiceDate:null,
                    noTaxAmount:0.0,
                    taxRate:null,
                    includeTaxAmount:null,
                    taxAmount:null,
                    currency:null,
                    totalMoney:0.0,
                    supplierCode:null,
                    supplierName:null,
                    companyCode:null,
                    orderNumber:null,
                    companyCodeType:null,
                    detailList:[],

                    recordList:[],//发票明细表
                },

                recordList:[{

                    id: this.$util.getUuid(),//发票附件名称
                    invoiceNumber: null,//发票号
                    invoiceCode: null,//发票代码
                    invoiceCategory: null,//发票类型
                    invoiceDate: null,//发票日期
                    noTaxAmount:0.0,//不含税金额（发票金额）
                    includeTaxAmount: null,//含税金额
                    taxAmount: null,//发票税额
                    fileUrl: null,//发票地址
                    fileName: null,//发票附件名称
                    taxRate: null,//税率
                    currency: null,//币种

                }],
                noTaxAmount:0.0,
                includeTaxAmount:0.0,
                taxAmount : 0.0,
                lists:[],
                ttdata:[],
            }
        },
        methods: {
            handleSelectionChange(lists){
                this.lists = lists;
            },
            //计算发票金额
            calMoney(){
                this.noTaxAmount=0.0;
                this.includeTaxAmount=0.0;
                console.log("testststs", this.ttdata)
                this.ttdata.forEach(element => {
                  //  this.noTaxAmount=parseFloat(new big(this.noTaxAmount).plus(element.amount));
                    // this.includeTaxAmount=parseFloat(new big(this.includeTaxAmount).plus(element.includeTaxAmount).toFixed(2));
                    this.form.taxRate = element.taxCode;
                    this.form.currency = element.currency;
                    this.recordList[0].taxRate = element.taxCode;
                    this.recordList[0].currency = element.currency;

                });
              //  this.form.noTaxAmount = this.noTaxAmount.toFixed(2);
            //    this.form.totalMoney = this.noTaxAmount.toFixed(2);
            },
            //方法区
            formatDate(row, column) {
                // 获取单元格数据
                let date = row[column.property];
                if (date) {
                    return this.transformDate(date)
                } else {
                    return ''
                }
            },
            //标准时间格式转yyyy-MM-dd
            transformDate(date) {
                if (date) {
                    let dt = new Date(date);
                    return dt.getFullYear() + '-' +
                        ((dt.getMonth() + 1) < 10 ? ('0' + (dt.getMonth() + 1)) : (dt.getMonth() + 1)) + '-' +
                        (dt.getDate() < 10 ? ('0' + dt.getDate()) : dt.getDate());
                } else {
                    return ''
                }
            },
            //提交数据
            submit(){
                for(var i=0;i<this.ttdata.length;i++){
                    if(this.ttdata[0].companyCode!=this.ttdata[i].companyCode){
                        this.$message.error("请选择同一公司主体开票");
                        return;
                    }
                    if(this.ttdata[0].supplierCode!=this.ttdata[i].supplierCode){
                        this.$message.error("请选择同一供应商开票");
                        return;
                    }
                    if(this.ttdata[0].taxCode!=this.ttdata[i].taxCode){
                        this.$message.error("请选择同一税率申请单开票");
                        return;
                    }
                    if(this.ttdata[0].currency!=this.ttdata[i].currency){
                        this.$message.error("请选择同一币种申请单开票");
                        return;
                    }

                }

                if(this.recordList.size==0){
                    this.$message.error("发票信息不能为空");
                    return;
                }

                this.noTaxAmount = 0.0;
                this.includeTaxAmount = 0.0;
                this.taxAmount = 0.0;
                for(var i=0;i<this.recordList.length;i++){
                    if(this.recordList[0].taxRate!=this.recordList[i].taxRate){
                        this.$message.error("发票税率必须相同");
                        return;
                    }
                    if(this.recordList[0].currency!=this.recordList[i].currency){
                        this.$message.error("发票币种必须相同");
                        return;
                    }
                    this.noTaxAmount = parseFloat(new big(this.noTaxAmount).plus(this.recordList[i].noTaxAmount).toFixed(2));//不含税金额合计
                    this.includeTaxAmount = parseFloat(new big(this.includeTaxAmount).plus(this.recordList[i].includeTaxAmount).toFixed(2));//含税价合计
                    this.taxAmount = parseFloat(new big(this.taxAmount).plus(this.recordList[i].taxAmount).toFixed(2));//含税价合计

                }
                //给主表设置字段
                this.form.taxRate =this.recordList[0].taxRate;
                this.form.currency = this.recordList[0].currency;
                this.form.totalMoney = this.noTaxAmount;//总金额
                this.form.noTaxAmount = this.noTaxAmount;//总金额
                this.form.includeTaxAmount = this.includeTaxAmount;//含税价合计
                this.form.taxAmount = this.taxAmount;//税额合计

                this.form.invoiceDate = this.recordList[0].invoiceDate;
                this.form.invoiceNumber = _.join(_.map(this.recordList,"invoiceNumber"),",");

                let taxAmount = this.form.taxAmount;
                let noTaxAmount = this.form.noTaxAmount;
                let includeTaxAmount = this.form.includeTaxAmount;
                let difference =  Number(taxAmount) + Number(noTaxAmount) - Number(includeTaxAmount)
                if (Math.abs(difference) > 1) {
                    this.$message.error("未税金额+发票税额与价税合计差额应控制在1之内!");
                    return;
                }
                console.log("this.form",this.form);


                for (let i = 0; i < this.recordList.length; i++) {

                    //根据发票类型校验附件类型（电票是xml,纸票可以是pdf或者jpg） 01.04.11纸票，其他都是电票
                    if(this.recordList[i].invoiceCategory=='01' || this.recordList[i].invoiceCategory=='04' || this.recordList[i].invoiceCategory=='11'  ){
                        if(this.recordList[i].fileName.indexOf('.pdf')==-1 && this.recordList[i].fileName.indexOf('.jpg')==-1){
                            this.$message.error("第"+(i+1)+"行发票类型是纸票附件必须是pdf或者jpg格式!");
                            return;
                        }
                    }else{
                        if(this.recordList[i].fileName.indexOf('.xml')==-1 ){
                            this.$message.error("第"+(i+1)+"行发票类型是电票附件必须是xml格式!");
                            return;
                        }
                    }


                    if(!this.recordList[i].invoiceNumber){
                        this.$message.error("第"+(i+1)+"行发票号码不能为空");
                        return;
                    }

                    if(!this.recordList[i].invoiceCategory){
                        this.$message.error("第"+(i+1)+"行发票类型不能为空");
                        return;
                    }
                    if(!this.recordList[i].fileUrl){
                        this.$message.error("第"+(i+1)+"行附件不能为空");
                        return;
                    }

                    if(!this.recordList[i].invoiceDate){
                        this.$message.error("第"+(i+1)+"行发票日期不能为空");
                        return;
                    }
                    if(!this.recordList[i].noTaxAmount){
                        this.$message.error("第"+(i+1)+"行发票金额不能为空");
                        return;
                    }
                    if(!this.recordList[i].taxAmount){
                        this.$message.error("第"+(i+1)+"行发票税额不能为空");
                        return;
                    }
                }

                this.form.recordList = this.recordList;



                ss.invoiceApplyList.saveInvoiceTs(this.form).then(rd=> {
                    if(rd.f){
                        this.$message.success("保存成功");
                        this.$emit('saveorsubmit')
                    }else{
                        this.$message.error(rd.msg);
                    }
                });
            },



            //附件
            fileBack1(v,refid) {
                console.log("附件信息",v)
                console.log("refid",refid)
                if(v.length>0){
                    const one = _.find(this.recordList,{id:v[0].refid})
                    one.fileName = v[0].name;
                    one.fileUrl = "http://"+process.env.VUE_APP_AJAXURL+"/"+v[0].saveurl;

                    //判断是不是xml
                    if(v[0].filetype.indexOf("xml")){
                        //识别xml
                        ss.invoiceApplyList.getEinvoiceByXmlFile(one.fileUrl).then(rd => {
                            console.log(rd);
                            if(rd.f) {
                                one.invoiceNumber = rd.msg.taxSupervisionInfo.invoiceNumber;//号码
                                one.invoiceDate = rd.msg.taxSupervisionInfo.issueTime;//开票日期
                                one.noTaxAmount = rd.msg.einvoiceData.basicInformation.totalAmWithoutTax;//发票金额
                                one.includeTaxAmount = rd.msg.einvoiceData.basicInformation.totalTaxIncludedAmount;//价税合计
                                one.taxAmount = rd.msg.einvoiceData.basicInformation.totalTaxAm;//税额合计
                            }
                        });
                    }else{
                        //调用影像识别接口
                        ss.invoiceApplyList.vatInvoiceRecognize(v[0].id).then(rd=> {
                            console.log(rd);
                            if(rd.f){
                                one.invoiceNumber = rd.obj.vatInvoiceHaoma ;//号码
                                one.invoiceCode = rd.obj.vatInvoiceDaima ;//代码
                                one.invoiceDate = rd.obj.vatInvoiceIssueDate ;//开票日期
                                one.noTaxAmount = rd.obj.vatInvoiceTotal;//发票金额
                                one.taxRate = rd.obj.vatInvoiceTaxRateCode;//税率
                                one.includeTaxAmount = rd.obj.vatInvoiceTotalCoverTaxDigits;//价税合计
                                one.taxAmount = rd.obj.vatInvoiceTaxTotal;//税额合计
                            }
                        });
                    }
                }else{
                    const one = _.find(this.recordList,{id:refid})
                    one.fileName= null;
                    one.fileUrl = null;
                }

            },
            //添加框
            add() {
                var list = {
                    id: this.$util.getUuid(),//发票附件名称
                    invoiceNumber: '',//发票号
                    invoiceCode: '',//发票代码
                    invoiceCategory: '',//发票类型
                    invoiceDate: '',//发票日期
                    noTaxAmount:0.0,//不含税金额（发票金额）
                    includeTaxAmount: '',//含税金额
                    taxAmount: '',//发票税额
                    fileUrl: '',//发票地址
                    fileName: '',//发票附件名称

                    taxRate : this.ttdata[0].taxCode,//税率
                    currency : this.ttdata[0].currency,//币种

                }
                this.recordList.push(list)
            },
            //删除框
            delPlan(index, q) {
                this.$confirm('确认删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
                    .then(_ => {
                        this.recordList.splice(index, 1)

                    })
                    .catch(_ => {
                    });
            },

        },



        created() {
            this.ttdata = this.orderList;
            this.form.supplierCode = this.supplierCode;
            this.form.supplierName = this.supplierName;
            this.form.companyCode = this.companyCode;
            this.form.companyCodeType = this.companyCodeType;
            this.form.detailList=this.orderList;
            this.calMoney();
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            orderList: {
                type: Array,
            },
            supplierCode: {
                type: String,
            },
            supplierName: {
                type: String,
            },
            companyCode: {
                type: String,
            },
            companyCodeType: {
              type: String,
            },
        },
    }
</script>

<style>
    .createfp .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .createfp .el-dialog__body{
        padding: 20px;
    }
    .createfp .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .createfp .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .createfp  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .createfp .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .createfp .yxline{
        padding-top: 0;
    }
    .createfp .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .createfp .h-rowCon{
        padding-bottom: 0rem;
    }
    .createfp .h-formbLine .h-elformWrap-2{
        width: 30%;
        margin-left: 0.26rem;
    }
</style>
